// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import sessionAttendanceEntity from './entities/session-attendance.json';
import sessionAttendanceMenu from '../pages/session-attendance/menu.json';
import sessionAttendanceFullForm from '../pages/session-attendance/forms/full.json';
import sessionAttendanceContextForm from '../pages/session-attendance/forms/context.json';
import sessionAttendanceMiniForm from '../pages/session-attendance/forms/mini.json';
import sessionAttendanceLookupForm from '../pages/session-attendance/forms/lookup.json';
import sessionAttendanceTableView from '../pages/session-attendance/views/table.json';
import sessionAttendanceCardsView from '../pages/session-attendance/views/cards.json';
import sessionAttendanceDashboardView from '../pages/session-attendance/views/dashboard.json';

/** Тип запису «Реєстрація присутності» зі сторінками пакета: меню, форми та подання з pages/session-attendance/. */
export const sessionAttendanceDefinition: IRecordTypeDefinition = {
  ...sessionAttendanceEntity,
  views: assembleViewSet({
      table: sessionAttendanceTableView,
      cards: sessionAttendanceCardsView,
      dashboard: sessionAttendanceDashboardView,
  }),
  form: sessionAttendanceFullForm,
  forms: { full: sessionAttendanceFullForm, context: sessionAttendanceContextForm, mini: sessionAttendanceMiniForm, lookup: sessionAttendanceLookupForm },
  menu: sessionAttendanceMenu,
} as IRecordTypeDefinition;
